import { Box, styled } from '@mui/material';

/** Shared 75%-width centered wrapper for the detailed CF range graph. */
export const RangeGraphContainer = styled(Box)({
  fontSize: '1.5rem',
  fontWeight: '600',
  width: '75%',
  margin: 'auto',
});

export default RangeGraphContainer;
